import HTTPClient from './http-client';
//import { createUrl } from "../utils_functions";
const END_POINT = '/public/county/';

const options = {
  cache: {
    maxAge: 24 * 60 * 60 * 1000,
    exclude: { query: false }
  }
}
// https://api.simepar.br/telemetry/v1/public/county/-3.0916541/-60.0110067
const loadCounty = async ({latitude,longitude}) => {
  const httpClient = new HTTPClient();
  const api = await httpClient.configure();
  return api.get(
    `${END_POINT}${latitude}/${longitude}`,
    options
  );
}

export {
  loadCounty,
}
